
import { Component, Vue } from 'vue-property-decorator'
import { ReporterService } from '@/services/index'

@Component({
    components: {
    }
})
export default class extends Vue {
    private mergeLogs = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = true 

    private mounted() {
        this.getMergeLogs()
    }

    private async getMergeLogs() {
        const params = { page_index: this.pageIndex, page_size: this.pageSize }
        const result = await ReporterService.getMergeLogs(params)
        if (result.status === 200) {
            this.mergeLogs = result.data.logs
            this.pageTotal = result.data.page_total
        }
        this.loading = false
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getMergeLogs()
        $backtop.scrollToTop()
    }
}
